export default __webpack_public_path__ + "static/media/logo192x192.61c7e23d.png";